import React from 'react';

export interface FullScreenLayoutProps {
    children: React.ReactNode;
    header?: React.ReactNode;
    className?: string;
    backgroundColor?: string;
}

/**
 * FullScreenLayout - GNB 없는 전체 화면 레이아웃
 *
 * 전체 화면 페이지용 레이아웃
 * - GNB/Footer 없음
 * - 고정 헤더 + 스크롤 가능한 컨텐츠 영역
 * - SimulationResults, ClassCurriculum 등에 사용
 */
export const FullScreenLayout: React.FC<FullScreenLayoutProps> = ({
    children,
    header,
    className = '',
    backgroundColor
}) => {
    const bgClass = backgroundColor ?? 'bg-gray-50';
    return (
        <div className={`flex h-dvh max-h-dvh flex-col overflow-hidden ${bgClass} ${className}`.trim().replace(/\s+/g, ' ')}>
            {header && (
                <header className="flex-none sticky top-0 bg-white border-b border-slate-200 shadow-sm z-20">
                    {header}
                </header>
            )}
            <div className="flex-1 flex flex-col min-h-0">
                {children}
            </div>
        </div>
    );
};
